// extracted by mini-css-extract-plugin
export default {"assessment_card":"cards_assessment_card__XHT8y"};